import { createSelector } from '@app/utils/createSelector'

import type { Location, NavigationAction } from '@app/packages/routing/types'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const uiMenuSlice = createReduxSlice<{ opened: boolean }>('ui_menu')

/** A REPLACE that only rewrites the url keeps the menu open; anything the user actually navigated to closes it. */
export const hideSideMenuOnNavigateSlice = (payload: { location: Location; action: NavigationAction }) =>
  uiMenuSlice.update(state => {
    if (payload.action !== 'REPLACE' || payload.location.state?.link || payload.location.state?.hard) return { ...state, opened: false }
    return state
  })

export const sideMenuOpenedSelector = createSelector([uiMenuSlice.selector], state => !!state?.opened)

export function toggleSideMenu() {
  return createThunk(dispatch => {
    const opened = !!dispatch(uiMenuSlice.get())?.opened

    dispatch(uiMenuSlice.set({ opened: !opened }))
  })
}

export function hideSideMenuIfOpened() {
  return createThunk(dispatch => {
    const opened = !!dispatch(uiMenuSlice.get())?.opened
    if (opened) dispatch(uiMenuSlice.set({ opened: false }))
  })
}
